import {updateField} from "vuex-map-fields"
import {Api} from "@/plugins/axios"
import {errorHandler} from "@/plugins/errorHandler"
import {getField} from "vuex-map-fields"

export const state = () => ({
    events: [],
    filters: null,
    event_loading: false,
    current_lead_id: null
})

export const mutations = {
    updateField,
    setEvents(state, events) {
        state.events = events
    },
    loading(state) {
        state.event_loading = true
    },
    done_loading(state) {
        state.event_loading = false
    },
    addEvent(state, event) {
        state.events.unshift(event)
    },
    addConversation(state, conversation) {
        let found = state.events.find(function (event) {
            return event.event_type === 'email' && event.data.id === conversation.id
        })
        if (found) {
            found.data = conversation
            found.time = conversation.conversation_messages[0].created
            return
        }
        state.events.unshift({data: conversation, event_type: 'email', time: conversation.conversation_messages[0].created})
    }
}

export const actions = {
    async loadTimeline({commit, state}, payload) {
        // Accept either a bare lead id (legacy callers) or { lead_id, skipCache }.
        const lead_id = (payload && typeof payload === 'object') ? payload.lead_id : payload
        const skipCache = (payload && typeof payload === 'object') ? !!payload.skipCache : false
        if ( !lead_id || typeof(lead_id) === 'undefined' ) return

        state.current_lead_id = lead_id
        commit('loading')
        let {data: {events, errors, message}, status} = await Api.post('/api/v1/client-leads/get-lead-activities/' + lead_id, { filters: state.filters, skipCache }).catch(e => e)
        commit('done_loading')
        if (errorHandler(status, message, errors)) return
        if (state.current_lead_id !== lead_id) return
        commit('setEvents', events)
    },
}

export const getters = {
    getField
}
